// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tour-categories {
  --category-side-margin: var(--large-spacing);
}
tour-categories drop-down-menu .drop-down-menu.fade-down.open {
  height: min(100%, var(--header-height) + 700px);
}
tour-categories .tours-container {
  display: flex;
  flex-direction: column;
}
tour-categories .tours-container .category {
  margin-bottom: var(--small-spacing);
}
tour-categories .tours-container .category horizontal-scroll {
  --element-width: min(300px, 80vw);
  --side-margin: var(--category-side-margin);
  --between-items-spacing: var(--medium-spacing);
}
tour-categories .tours-container .category mini-tour .meta-editing {
  display: flex;
  flex-direction: column;
  padding: var(--small-spacing);
  box-sizing: border-box;
}
tour-categories .tours-container .category mini-tour .meta-editing .meta-input {
  display: flex;
  justify-content: space-between;
}
tour-categories .tours-container .category mini-tour .meta-editing .meta-input label {
  margin-right: var(--small-spacing);
}
tour-categories .tours-container .category mini-tour .meta-editing .meta-input input {
  width: 80%;
}
tour-categories .tours-container .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--medium-spacing) var(--category-side-margin) 0 var(--category-side-margin);
  box-sizing: border-box;
}
tour-categories .tours-container .header h3 {
  margin: 0;
}
tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
  --cards-pr-row: 1;
  display: grid;
  grid-template-columns: repeat(var(--cards-pr-row), 1fr);
  column-gap: var(--large-spacing);
  row-gap: var(--large-spacing);
  padding: var(--large-spacing) var(--category-side-margin);
  box-sizing: border-box;
  padding-top: var(--small-spacing);
}
@media all and (min-width: 500px) {
  tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
    --cards-pr-row: 2;
  }
}
@media all and (min-width: 800px) {
  tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
    --cards-pr-row: 3;
  }
}
@media all and (min-width: 1100px) {
  tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
    --cards-pr-row: 4;
  }
}
@media all and (min-width: 1400px) {
  tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
    --cards-pr-row: 5;
  }
}
@media all and (min-width: 1700px) {
  tour-categories .tours-container .tour-grid, tour-categories .tours-container .city-grid {
    --cards-pr-row: 6;
  }
}
tour-categories .tours-container .tour-grid .mini-tour, tour-categories .tours-container .city-grid .mini-tour {
  width: auto;
}
tour-categories .tours-container .tour-search-container {
  padding: var(--large-spacing) var(--category-side-margin);
  box-sizing: border-box;
  padding-bottom: 0;
  padding-top: 0;
  margin-top: var(--medium-spacing);
}
tour-categories .tours-container .city-grid {
  row-gap: var(--small-spacing);
  transition: 200ms ease-in-out;
  overflow: hidden;
}
tour-categories .tours-container .city-grid-0 {
  padding: 0;
  min-height: 0px;
  max-height: 0px;
}
tour-categories .tours-container .city-grid-1 {
  max-height: 55px;
  min-height: 55px;
}
tour-categories .tours-container .city-grid-2 {
  max-height: 110px;
  min-height: 110px;
}
tour-categories .tours-container .city-grid-3 {
  max-height: 160px;
  min-height: 160px;
}
tour-categories .tours-container .city-box {
  cursor: pointer;
  background-color: var(--motes-dark-gray);
  padding: 4px;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
}
tour-categories .tours-container .city-icon {
  font-size: 30px;
  padding-top: 3px;
  margin-right: var(--motes-padding);
}
@media only screen and (max-width: 600px) {
  tour-categories horizontal-scroll {
    --category-side-margin: var(--large-spacing);
    --between-items-spacing: var(--medium-spacing);
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/tour-categories/tour-categories.component.scss"],"names":[],"mappings":"AAAA;EACI,4CAAA;AACJ;AACI;EACI,+CAAA;AACR;AAEI;EACI,aAAA;EACA,sBAAA;AAAR;AAEQ;EACI,mCAAA;AAAZ;AAEY;EACI,iCAAA;EACA,0CAAA;EACA,8CAAA;AAAhB;AAKgB;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;AAHpB;AAKoB;EACI,aAAA;EACA,8BAAA;AAHxB;AAKwB;EACI,kCAAA;AAH5B;AAMwB;EACI,UAAA;AAJ5B;AAWQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wFAAA;EACA,sBAAA;AATZ;AAWY;EACI,SAAA;AAThB;AAaQ;EACI,iBAAA;EAOA,aAAA;EACA,uDAAA;EACA,gCAAA;EACA,6BAAA;EACA,yDAAA;EACA,sBAAA;EACA,iCAAA;AAjBZ;AAKY;EAFJ;IAEyC,iBAAA;EAD/C;AACF;AACY;EAHJ;IAGyC,iBAAA;EAG/C;AACF;AAHY;EAJJ;IAIyC,iBAAA;EAO/C;AACF;AAPY;EALJ;IAKyC,iBAAA;EAW/C;AACF;AAXY;EANJ;IAMyC,iBAAA;EAe/C;AACF;AANY;EACI,WAAA;AAQhB;AAJQ;EACI,yDAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;AAMZ;AAHQ;EACI,6BAAA;EAEA,6BAAA;EACA,gBAAA;AAIZ;AADQ;EACI,UAAA;EACA,eAAA;EACA,eAAA;AAGZ;AAAQ;EACI,gBAAA;EACA,gBAAA;AAEZ;AACQ;EACI,iBAAA;EACA,iBAAA;AACZ;AAEQ;EACI,iBAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,eAAA;EACA,wCAAA;EAEA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;AAHZ;AAQI;EACI;IACI,4CAAA;IACA,8CAAA;EANV;AACF","sourcesContent":["tour-categories {\n    --category-side-margin: var(--large-spacing);\n    \n    drop-down-menu .drop-down-menu.fade-down.open {\n        height: min(100%, calc(var(--header-height) + 700px));\n    }\n\n    .tours-container {\n        display: flex;\n        flex-direction: column;\n\n        .category {\n            margin-bottom: var(--small-spacing);\n\n            horizontal-scroll {\n                --element-width: min(300px, 80vw);\n                --side-margin: var(--category-side-margin);\n                --between-items-spacing: var(--medium-spacing);\n            }\n\n            mini-tour {\n\n                .meta-editing {\n                    display: flex;\n                    flex-direction: column;\n                    padding: var(--small-spacing);\n                    box-sizing: border-box;\n\n                    .meta-input {\n                        display: flex;\n                        justify-content: space-between;\n\n                        label {\n                            margin-right: var(--small-spacing);\n                        }\n\n                        input {\n                            width: 80%;\n                        }\n                    }\n                }\n            }\n        }\n\n        .header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: var(--medium-spacing) var(--category-side-margin) 0 var(--category-side-margin);\n            box-sizing: border-box;\n\n            h3 {\n                margin: 0;\n            }\n        }\n\n        .tour-grid, .city-grid {\n            --cards-pr-row: 1;\n            @media all and (min-width: 500px)  { --cards-pr-row: 2; }\n            @media all and (min-width: 800px)  { --cards-pr-row: 3; }\n            @media all and (min-width: 1100px) { --cards-pr-row: 4; }\n            @media all and (min-width: 1400px) { --cards-pr-row: 5; }\n            @media all and (min-width: 1700px) { --cards-pr-row: 6; }\n\n            display: grid;\n            grid-template-columns: repeat(var(--cards-pr-row), 1fr);\n            column-gap: var(--large-spacing);\n            row-gap: var(--large-spacing);\n            padding: var(--large-spacing) var(--category-side-margin);\n            box-sizing: border-box;\n            padding-top: var(--small-spacing);\n\n            .mini-tour {\n                width: auto;\n            }\n        }\n\n        .tour-search-container {\n            padding: var(--large-spacing) var(--category-side-margin);\n            box-sizing: border-box;\n            padding-bottom: 0;\n            padding-top: 0;\n            margin-top: var(--medium-spacing);\n        }\n\n        .city-grid {\n            row-gap: var(--small-spacing);\n            // margin-bottom: var(--small-spacing);\n            transition: 200ms ease-in-out;\n            overflow: hidden;\n        }\n\n        .city-grid-0 {\n            padding: 0;\n            min-height: 0px;\n            max-height: 0px;\n        }\n\n        .city-grid-1 {\n            max-height: 55px;\n            min-height: 55px;\n        }\n\n        .city-grid-2 {\n            max-height: 110px;\n            min-height: 110px;\n        }\n        \n        .city-grid-3 {\n            max-height: 160px;\n            min-height: 160px;\n        }\n\n        .city-box {\n            cursor: pointer;\n            background-color: var(--motes-dark-gray);\n            // padding: var(--motes-padding);\n            padding: 4px;\n            border-radius: var(--border-radius);\n            display: flex;\n            align-items: center;\n        }\n\n        .city-icon {\n            font-size: 30px;\n            padding-top: 3px;\n            margin-right: var(--motes-padding);\n        }\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n        horizontal-scroll {\n            --category-side-margin: var(--large-spacing);\n            --between-items-spacing: var(--medium-spacing);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
